import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	emptyStateHeader: {
		id: 'navigation-global-side-navigation.object-list-flyout.empty-state.header',
		defaultMessage: 'Nothing to see here!',
		description: 'Message for the header of the default empty state in the object list flyout',
	},
	emptyStateDescription: {
		id: 'navigation-global-side-navigation.object-list-flyout.empty-state.description',
		defaultMessage:
			'Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they’ll show up here.',
		description: 'Message for the description of the default empty state in the object list flyout',
	},
});

export default messages;
